import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-announce-pice-thesis-edit',
  templateUrl: './announce-pice-thesis-edit.component.html',
  styleUrls: ['./announce-pice-thesis-edit.component.sass'],
})
export class AnnouncePiceThesisEditComponent implements OnInit {
  public priceFormControl = new FormControl('', [
    Validators.required,
    Validators.min(1000),
  ]);

  constructor(
    private dialogRef: MatDialogRef<AnnouncePiceThesisEditComponent>
  ) {}
  ngOnInit(): void {}

  closeWithPrice() {
    if (this.priceFormControl.valid) {
      this.dialogRef.close(this.priceFormControl.value);
    }
  }
}
